import { API } from '../apis/limeAuthUtils/apiWrapper';
import { getCurrentAuthUserAlias } from '../lib/utils';

export async function createTmpCred() {
    /**
     * function to call api to get tmp aws credential
     */
    const authenticatedUserAlias = await getCurrentAuthUserAlias();
    console.log('Authenticated user: ', authenticatedUserAlias);
    const apiName = 'v2/permission-validate';
    const myInit = {
        body: {
            user: authenticatedUserAlias,
        },
    };
    return await API.post(apiName, '/v2/create_tmp_cred', myInit);
}

export async function credToCSVData() {
    /**
     * function to transform aws credential to csv data
     */
    try {
        const response = await createTmpCred();
        const credential = response['credential'];
        const credential_csv_data = [
            {
                access_key_id: credential['AccessKeyId'],
                secret_access_key: credential['SecretAccessKey'],
                aws_session_token: credential['SessionToken'],
            },
        ];
        return credential_csv_data;
    } catch (e) {
        console.error(e);
        return [];
    }
}
